<template>
    <v-card style="box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25); min-width: 900px;" class="d-flex flex-column chart-to-image-dialog">
        <div ref="download-image">
            <v-layout pa-3 class="titleCard" style="flex: 0">
                <v-flex shrink class="d-flex align-center">
                    <v-icon large class="mr-3 cea-color">bar_chart</v-icon>
                </v-flex>
                <v-flex class="text-left" style="font-size: 22px">
                    <div v-if="chartToImage.title.length > 70" class="font-weight-bold">
                        <div>{{chartToImage.title.substr(0, 68)}}</div>
                        <div>{{chartToImage.title.substr(68, chartToImage.title.length - 68)}}</div>
                    </div>
                    <div v-else class="font-weight-bold">{{chartToImage.title}}</div>
                </v-flex>
                <v-flex shrink align-center style="display: flex">
                    <a href="https://cea.or.th">
                        <img style="width: 100px;user-select: none;cursor: pointer"
                             :src="require('../assets/cea-logo.png')"/>
                    </a>
                </v-flex>
            </v-layout>

            <v-layout px-7 py-3 style="flex: 1;">
                <v-flex class="d-flex align-center" style="padding: 20px; box-shadow: 0 0 5px rgba(0,0,0,0.25);">
                    <div style="width: 100%;" v-if="reloaded">
                        <template v-if="chartToImage.chart.type === chartType.pie">
                            <PieChart
                                    :dataname="chartToImage.chart.label"
                                    :chartdata="chartToImage.chart.labels"
                                    :options="chartToImage.chartData"
                                    :piecolor="chartToImage.chartOptions.piecolor"
                                    :chartOptions="chartToImage.chartOptions"
                                    displayLabels />
                        </template>

                        <template v-if="chartToImage.chart.type === chartType.donut">
                            <DoughnutChart
                                    :dataname="chartToImage.chart.label"
                                    :chartdata="chartToImage.chart.labels"
                                    :options="chartToImage.chartData"
                                    :dncolor="chartToImage.chartOptions.piecolor"
                                    :chartOptions="chartToImage.chartOptions"
                                    displayLabels />
                        </template>

                        <template v-if="chartToImage.chart.type === chartType.barH">
                            <HorizontalBarChart
                                    :dataname="chartToImage.chart.label"
                                    :chartdata="chartToImage.chart.labels"
                                    :options="chartToImage.chartData"
                                    :chartOptions="chartToImage.chartOptions"
                                    displayLabels />
                        </template>

                        <template v-if="chartToImage.chart.type === chartType.barV">
                            <BarChart
                                    :dataname="chartToImage.chart.label"
                                    :chartdata="chartToImage.chart.labels"
                                    :options="chartToImage.chartData"
                                    :chartOptions="chartToImage.chartOptions"
                                    />
                        </template>

                        <template v-if="chartToImage.chart.type === chartType.line">
                            <LineChart
                                    :dataname="chartToImage.chart.label"
                                    :chartdata="chartToImage.chart.labels"
                                    :options="chartToImage.chartData"
                                    :linecolor="chartToImage.chartOptions.linecolor"
                                    :pointcolor="chartToImage.chartOptions.pointcolor"
                                    :chartOptions="chartToImage.chartOptions"
                                    displayLabels />
                        </template>
                    </div>
                </v-flex>
            </v-layout>

            <template v-if="chartToImage.referenceText">
                <v-layout px-7>
                    <span>{{ $t('general.reference') }}: {{ chartToImage.referenceText }}</span>
                </v-layout>
            </template>

            <v-layout justify-start py-3 px-7 style="flex: 0">
                <v-flex shrink class="text-left">
                    <strong style="font-size: 18px">{{ chartToImage.caption }}</strong>
                </v-flex>
            </v-layout>
        </div>

        <div class="ma-4">
            <v-btn dark color="#FF4F23" class="mr-3" @click="downloadChartImage">download</v-btn>
            <v-btn dark color="#FF4F23" class="mr-3" @click="downloadExcel">excel</v-btn>
            <v-btn dark color="#FF4F23" @click="shareChart(chartToImage.id)">share</v-btn>
        </div>
    </v-card>
</template>

<script>
    import {mapState, mapActions} from 'vuex'
    import {chartType} from '../utils/Constants'
    import { domain } from '../services/Constants'

    import BarChart from './BarChart'
    import DoughnutChart from './DoughnutChart'
    import HorizontalBarChart from './HorizontalBarChart'
    import LineChart from './LineChart'
    import PieChart from './PieChart'

    import XLSX from 'xlsx'

    export default {
        name: "PreviewChartExportDialog",
        props: ['isDialogShow'],
        components: {
            BarChart,
            DoughnutChart,
            HorizontalBarChart,
            LineChart,
            PieChart,
        },
        computed: {
            ...mapState({
                chartToImage: state => state.chart.chartToImage,
                language: state => state.locale.language
            })
        },
        data: () => ({
            // dialog: false,
            chartType: chartType,
            reloaded: false
        }),
        mounted() {
            this.$nextTick(() => {
                this.reloaded = true;
            });
        },
        methods: {
            ...mapActions('chart', ['uploadChartImage']),
            async shareChart(statisticId) {
                const el = this.$refs['download-image'];
                // add option type to get the image version
                // if not provided the promise will return
                // the canvas.
                // const options = {
                //   type: 'dataURL'
                // }
                this.output = await this.$html2canvas(el)

                const image = this.output.toDataURL("image/jpeg", 1.0).replace("image/jpeg", "image/octet-stream")

                await this.uploadChartImage({
                    base64: image,
                    fileName: `statistic_${statisticId}`
                })

                const redirect_url = this.$route.path.split('/')
                    ? this.$route.path.split('/')[1]
                    : ''

                const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${domain}/statistic/${statisticId}/${this.language}/${redirect_url}`

                window.open(shareUrl, '_blank');
            },
            async downloadChartImage() {
                console.log(this.$refs['download-image'])
                const el = this.$refs['download-image'];
                // add option type to get the image version
                // if not provided the promise will return
                // the canvas.
                // const options = {
                //   type: 'dataURL'
                // }

                this.output = await this.$html2canvas(el)
                console.log(this.output)

                const image = this.output.toDataURL("image/jpeg", 1.0).replace("image/jpeg", "image/octet-stream")
                console.log(image)
                const link = document.createElement('a')
                link.download = "export-chart-image.jpg"
                link.href = image
                link.click()
            },
            downloadExcel () {
                let chartData = [];
                for (let i = 0; i < this.chartToImage.chartData.length; i++) {
                    chartData.push({
                        Label: this.chartToImage.chart.labels[i],
                        Data: this.chartToImage.chartData[i]
                    });
                }
                // console.log(chartData)
                const sheet = XLSX.utils.json_to_sheet(chartData);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, sheet);
                XLSX.writeFile(wb,'export-chart.xlsx');
            }
        }
    }
</script>

<style scoped>
    .chart-to-image-dialog {
        overflow-wrap: normal;
    }
</style>
